<template>
  <div class="headers">
    <PC v-if="!isMobile" :category="category" :contact="contact" />
    <Mobile v-if="isMobile" :category="category" :contact="contact" :onShow="onShow" />
  </div>
</template>

<script>
import PC from './pc'
import Mobile from './mobile'
import { _isMobile, category, contact } from '@/utils/config'

export default {
  name: 'headers',
  props: {
    onShow: Function,
  },
  components: { PC, Mobile },
  data() {
    return {
      isMobile: _isMobile(),
      category,
      contact,
    }
  },
}
</script>
